import Card from "@mui/material/Card";
import {
  Component
} from "react";
import MatchPageUI from '../../../dictionaries/MatchPageUI.dic';
import {
  Arr,
  join
} from '../../../lib/Array.lib';
import {
  NOT
} from '../../../lib/Boolean.lib';
import Candidate from "../../../lib/Candidate";
import {
  MDASH
} from '../../../lib/Constants';
import Core from "../../../lib/Core";
import Definition, {
  ACCOUNT_ACTION__MATCH_CANDIDATE,
  ACCOUNT_ACTION__RESUME_SUBMISSION,
  ACCOUNT_ACTION__VIEW_ENGAGEMENT,
  DEFINITION_CATEGORY__MATCH_TYPE
} from "../../../lib/Definition";
import Engagement from "../../../lib/Engagement";
import {
  YES
} from '../../../lib/GenericTools.lib';
import {
  Obj
} from '../../../lib/Object.lib';
import {
  joinKeyName,
  trim
} from '../../../lib/String.lib';
import {
  matchLocation
} from '../../../lib/URL.lib';
import {
  getJoinedFeedbackOrRejectionReason
} from '../../../lib/models/EngagementFeedback.model';
import {
  mapCandidate,
  mapCandidateTechSkills
} from '../../../lib/models/candidate';
import {
  mapEngagement
} from '../../../lib/models/engagement';
import MoreOptionsMenu from '../../Home/3DotsMenu/MoreOptionsMenu';
import {
  moreMenuOptionsCandidates
} from '../../Home/3DotsMenu/moreMenuOptionsCandidates';
import {
  moreMenuOptionsEngagements
} from '../../Home/3DotsMenu/moreMenuOptionsEngagements';
import {
  joinClassName
} from '../../Layout/Libraries/Theme.lib';
import Box, {
  RefBox
} from '../../Layout/Wrappers/Box';
import Button from '../../Layout/Wrappers/Button';
import Chip from '../../Layout/Wrappers/Chip';
import IconButton from '../../Layout/Wrappers/IconButton';
import NavLink from '../../Layout/Wrappers/NavLink';
import Once from '../../Layout/Wrappers/Once';
import {
  PLACEMENT__TOP_END
} from '../../Layout/Wrappers/StyledTooltip';
import Switch from '../../Layout/Wrappers/Switch';
import Typography from '../../Layout/Wrappers/Typography';
import {
  getMLStatsString
} from '../Libraries/Match.lib';
import {
  getMatchEntities,
  KEY__CON__SINGLE_CARD
} from '../Libraries/MatchList.lib';
import getJobLabels from '../Libraries/Tools/getJobLabels.tool';
import getOwnershipChip from '../Libraries/Tools/getOwnershipChip.tool';
import onSelectMatch from '../Libraries/Tools/onSelectMatch.tool';
import {
  MatchPage__addKeyword,
  MatchPage__getState,
  MatchPage__removeKeyword
} from '../MatchPage';
import CardCheckbox from "./CardCheckbox";
import CounterSingleCard from './CounterSingleCard';
import CreateDisagreement from "./CreateDisagreement";
import {
  ListPipeController
} from './ListPipe';
import ManageEngagement from "./ManageEngagement";
import MatchDecisionDetails, {
  MATCH_DECISION_DETAILS__CONFIG
} from './MatchDecisionDetails';
import MatchDecisionMaker from './MatchDecisionMaker';
import MatchLocationChips, {
  MATCH_LOCATION_CHIPS__CD_REQUESTER
} from "./MatchLocationChips";
import ThumbsBar from "./ThumbsBar";

class SingleCandidateCard extends Component {
  constructor() {
    super(...arguments);
    this.role = 'SingleCandidateCard';
    this.state = {
      ...this.props,
      showQuestions: false,
      wantsUpdateEngagement: false,
      reviewed: false,
      MlDecisionPending: true,
      matchDecisions: [],
    };
    const {
      match = {}
    } = this.props;
    Object.assign(match, {
      [KEY__CON__SINGLE_CARD]: this
    });
  }

  componentDidMount() {
    const {
      match = {}
    } = this.state;
    if (!this.state.processedOwnerships) {
      this.setState({ processedOwnerships: true });
      if (match.id) {
        Candidate.getPotentialDuplicatedWithOwnerships(match).then((result) => {
          match.jobOwnerships = Arr(result);
          Engagement.getWhereV2(
            { candidateId: match.id },
            {
              include: [
                {
                  relation: "job",
                  scope: {
                    fields: ["id", "employerId", "jobTitle", "roles", 'visaTransfer', 'technicalSkills'],
                    include: [
                      {
                        relation: "employer",
                        scope: {
                          fields: ["id", "name"],
                        },
                      },
                    ],
                  },
                },
              ],
              fields: [
                "id",
                "jobId",
                "candidateId",
                "stage",
                "status",
                "state",
                "lastAction",
              ],
            }, {}, { source: `single_candidate_card__component_did_mount` }
          ).then(
            (engagements) => {
              match.engagements = engagements;
              this.setState({ match });
            }
          );
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.isSelected !== this.props.isSelected) {
      this.setState({ isSelected: this.props.isSelected });
    }
    if (prevState.job !== this.props.job) {
      this.setState({ job: this.props.job });
    }
  }

  afterUpdateEngagement = (update = {}) => {
    const { afterMainUpdateEngagement } = this.props;
    const {
      engagement = {}
    } = this.state;
    Object.assign(engagement, update);
    this.setState({ engagement },
      () => afterMainUpdateEngagement(engagement)
    );
  };

  closeParentPopup = () => {
    this.setState({ wantsUpdateEngagement: false });
  };

  handlerUpdateEngagement = () => {
    this.setState({ wantsUpdateEngagement: true });
  };

  handlerOnSelect = () => {
    const {
      type = '',
    } = this.props;
    const {
      match = {},
      engagement = {}
    } = getMatchEntities(this.state);
    const newSelectedMatch = type === 'engagement' ? engagement : match;
    onSelectMatch(newSelectedMatch);
    ListPipeController().resizeIndex(
      this.props.index
    );
  };

  handlerMlDecisionMaking = (status, MlDecisionMakers) => {
    this.setState(
      {
        MlDecisionPending: status,
        matchDecisions: MlDecisionMakers,
      },
      () => ListPipeController().resizeIndex(
        this.props.index
      )
    );
  };

  render() {
    const {
      profile = {},
      match = {},
      engagement = {},
      recruiter = {},
    } = getMatchEntities(this.state);
    const {
      wantsUpdateEngagement,
      reviewed,
      MlDecisionPending,
      matchDecisions,
    } = this.state;
    const {
      type = '',
      isSelected = false,
      handlerOnSelectBox,
      selectedMatches,
      segregateRolesChip,
      updateEngagement,
      measure,
      registerChild,
      label = '',
      index = 0,
      style = {}
    } = this.props;

    const cardStyle = {
      margin: '0px 2px',
      width: 'calc(100% - 4px)'
    };

    if (isSelected) {
      cardStyle.outline = `2px solid ${colors.purple.common}`;
    }
    if (type === 'engagement') {
      cardStyle.backgroundColor = 'LightGrey';
    }
    else if (match.isDuplicate) {
      cardStyle.backgroundColor = 'LightPink';
    }

    const mlStatsJoined = getMLStatsString({
      mlScoreObject: match.mlScoreObject
    });

    let { keywords = [] } = MatchPage__getState();

    let isFilterByRecruiter = !!keywords.find(k => k.name === recruiter._name);

    let ownerShipChipLabel = Obj(Obj(Arr(this.state.ownerShipChip)[0]).props)['data-label'];
    let isAlreadyOwnIt = ownerShipChipLabel === 'iAlreadyOwnIt';
    if (this.state.isAlreadyOwnIt !== isAlreadyOwnIt) {
      setTimeout(() => this.setState({ isAlreadyOwnIt }));
    }

    const _engagementId = engagement.id
    const _hasCheckedOrEngagementId = (!!this.state.checked || !!_engagementId);
    const _hasRequiredFields = (!!_engagementId && !!profile.id && !!match.id);
    const _isAdminAndHasCheckedOrEngagement = Core.isAdmin() && _hasCheckedOrEngagementId;
    const _menuOptions = [

      // SUBMISSION
      {
        acl: (
          Core.isAdmin({ action: ACCOUNT_ACTION__RESUME_SUBMISSION }) &&
          _hasCheckedOrEngagementId &&
          _hasRequiredFields
        ),
        label: 'Submission',
        action: (ev) => Core.go({ ...(this?.props || {}), to: `/candidate/resume-submission/${match.id}/${profile.id}` })
      },

      // CALCULATE MATCH SCORE
      {
        label: 'Calculate Match Score',
        action: () => {
          match.mlScore = "calculating";
          match.mlScoreObject = {};
          this.setState({ match });
          ListPipeController().processMLScoreSingle(
            {
              jobId: profile.id,
              candoIds: [match.id],
            },
            'get_candos_scores',
            (results) => {
              const thisJobResult = Obj(
                results.find(
                  (result) => result.item_id === match.id
                )
              );
              if (thisJobResult.match) {
                match.mlScore = thisJobResult.match.score;
                match.mlScoreObject = thisJobResult.match;
                this.setState({ match });
              }
            }
          );

        }
      },

      // UPDATE ENGAGEMENT type II
      {
        acl: !!_engagementId,
        label: 'Update Engagement',
        action: () => this.handlerUpdateEngagement()
      },

      // MATCH DECISION DETAILS
      {
        acl: Core.isAdmin() && !!_engagementId,
        label: MATCH_DECISION_DETAILS__CONFIG.dialog.title,
        action: () => this.matchDecisionDetails.open()
      },

      // MAKE ML POSITIVE
      {
        acl: _isAdminAndHasCheckedOrEngagement && !!_engagementId,
        label: 'Mark ML Positive',
        action: (ev) => {
          updateEngagement(engagement, {
            useForMlTraining: "true",
          });
        }
      },

      // MAKE ML NEGATIVE
      {
        acl: _isAdminAndHasCheckedOrEngagement && !!_engagementId,
        label: 'Mark ML Negative',
        action: (ev) => {
          updateEngagement(engagement, {
            useForMlTraining: "false",
          });
        }
      },

    ];

    const LABEL__TAG__MATCH_TYPE__ENGAGEMENT = Definition.getLabel(
      DEFINITION_CATEGORY__MATCH_TYPE,
      engagement.matchType
    );

    const YES__MATCH_TYPE__ENGAGEMENT = YES(trim(LABEL__TAG__MATCH_TYPE__ENGAGEMENT));

    const KEY__SINGLE_CARD = joinKeyName([
      'single_candidate_card',
      index,
    ]);

    return (
      <RefBox key={KEY__SINGLE_CARD}
        /**
         * @note
         * These are essential for recomputeRowHeights.
         * onLoad={measure} ref={registerChild} style={style}
         * Also this wrapper must be a forwardable element.
         */
        // ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼
        onClick={(event) => {
          measure(event);
        }}
        ref={(node) => {
          if (!node) return;
          registerChild(node);
          // onLoad is not available for div elements
          // so we need to store the node
          // to recompute the row height once ownership chip is loaded
          Core.setKeyValue(KEY__SINGLE_CARD, node);
        }}
        style={style}
        // ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲
        className='pb-05 flex-1 flex-column'
      >
        <Once
          render={false}
          promise={async () => {
            this.setState({
              ownerShipChip: await getOwnershipChip({ profile, match })
            }, () => {
              measure({
                target: Core.getKeyValue(KEY__SINGLE_CARD)
              });
            });
          }}
        />
        <Button role='GroupHeader' flat primary
          acl={
            YES(label) &&
            NOT(ListPipeController().state.annotatorMode)
          }
          label={label}
          className={
            joinClassName(
              [
                'mb-05 bg-purple-lighter',
                index ? 'mt-3' : 'mt-05'
              ]
            )
          }
          fullWidth
        />

        <Card
          onClick={this.handlerOnSelect}
          className='pointer relative'
          style={cardStyle}
        >

          <CounterSingleCard index={index} />

          <Box column w100 className='p-1'>
            <Box row w100 spaceBetween>
              <Box row w100>
                <Typography strong breakAll>
                  {match._name}
                </Typography>
              </Box>
              <Box row w100>
                <Switch small acl={NOT(matchLocation(/v3/i))}
                  checked={isFilterByRecruiter}
                  onChange={event => {
                    isFilterByRecruiter = event.target.checked;
                    if (isFilterByRecruiter) {
                      MatchPage__addKeyword(recruiter._name);
                    }
                    else {
                      MatchPage__removeKeyword(recruiter._name);
                    }
                  }}
                >
                  Recruiter filter
                </Switch>
                <CardCheckbox
                  entity={match}
                  handlerOnSelectBox={handlerOnSelectBox}
                  selectedCheck={
                    !!selectedMatches &&
                    selectedMatches.find((entity) => entity.id === match.id)
                  }
                />
              </Box>
            </Box>
            <Typography sub>
              {match._roles}
            </Typography>
          </Box>

          <Box className='px-1'>

            <Typography className='my-1 match-new job-card-text'>
              {recruiter._name}, {match._introduced}
            </Typography>

            <Box className='mt-1'>
              {!!match._visa &&
                this.props.staticRowDisplayChip(
                  match._visa,
                  profile._visaTransfer,
                  this.props
                    .staticRowDisplayColor(match, profile)
                    .getVisaColor()
                )}
              {!!segregateRolesChip && segregateRolesChip(match, profile)}
              {!!match.id && typeof match._yearsOfExperienceForCalc !== "undefined"
                ? this.props.staticRowDisplayChip(
                  match._yearsOfExperienceForCalc + " yrs",
                  profile.minYearsOfExperience,
                  this.props
                    .staticRowDisplayColor(match, profile)
                    .getYearsXp()
                )
                : null}

              <MatchLocationChips
                requester={MATCH_LOCATION_CHIPS__CD_REQUESTER}
                job={profile}
                candidate={match}
              />

              {!!profile.id &&
                typeof profile.minimumSalary !== "undefined" &&
                this.props.staticRowDisplayChip(
                  "<=$" + profile.minimumSalary,
                  match.salaryMax,
                  this.props
                    .staticRowDisplayColor(profile, match)
                    .getSalaryColor()
                )}
              {!!profile.id &&
                !!profile.platformRating &&
                this.props.staticRowDisplayChip(
                  profile._platformRating,
                  null,
                  null
                )}
            </Box>


            <Box
              acl={match._technicalSkills}
              className='mt-1'
            >
              Tech Skills: {mapCandidateTechSkills(match)}
            </Box>

            <Box
              acl={!!match.id && !!profile.id}
              className={joinClassName([
                'mt-1',
                (
                  ListPipeController().state.annotatorMode ||
                  !mlStatsJoined.length
                ) && 'd-none'
              ])}
            >
              <mark>{mlStatsJoined}</mark>
            </Box>

            <Box row flex1 className='mt-1'>
              <ThumbsBar
                Controller={this}
                profile={profile}
                match={match}
              />
              <Switch small
                checked={reviewed}
                onChange={(event) => {
                  this.setState({ reviewed: event.target.checked });
                }}
                className='ml-auto mr-05'
              >
                Reviewed
              </Switch>
            </Box>

            <Box column flex1
              className='mt-1'
            >

              <Typography
                acl={
                  !!engagement.id &&
                  !ListPipeController().state.annotatorMode
                }
              >
                {join([
                  engagement.state,
                  engagement.status,
                  engagement.stage,
                  getJoinedFeedbackOrRejectionReason(engagement),
                  engagement.rejectionReasonAdditionalInfo
                ], ' | ')}
              </Typography>

              {(!ListPipeController().state.annotatorMode
                ? (!MlDecisionPending
                  ? (
                    matchDecisions.map(
                      (decision, index) => (
                        <MatchDecisionMaker
                          key={`single_candidate_card__match_decision_maker__index_${index}`}
                          matchDecisionTableRecord={decision}
                          measure={measure}
                          index={index}
                        />
                      )
                    )
                  ) : (
                    <div className='my-1 match-new job-card-text'>
                      Loading decision...
                    </div>
                  )
                ) : null
              )}

              <Box row flex1 noWrap
                className='mt-1 flex-align-left-bottom'
              >

                {/** CHIPS LIST BAR */}
                <Box row flex1 wrap
                  acl={!!match.id}
                  className='mr-1'
                >
                  {/** LABELS: JOB STATUS */}
                  {getJobLabels({ job: profile, candidate: match }).map(
                    (label, index) => (
                      <Chip slim key={`single_candidate_card__labels__index_${index}`}
                        className='c-white px-1 mr-05 mb-05 f-md'
                        title={label}
                        placement={PLACEMENT__TOP_END}
                        style={{
                          backgroundColor: (
                            Object.keys(
                              MatchPageUI.CardChipBar.JobStatus
                            ).map(
                              (key) => (
                                MatchPageUI.CardChipBar.JobStatus[key]
                              )
                            ).find(
                              (obj) => (obj.label === label)
                            ).color
                          )
                        }}
                      >
                        {(label)}
                      </Chip>
                    )
                  )}

                  {/** LABEL: MATCH TYPE */}
                  {YES__MATCH_TYPE__ENGAGEMENT && (
                    <Chip slim
                      className='c-white px-1 mr-05 mb-05 f-md'
                      title={LABEL__TAG__MATCH_TYPE__ENGAGEMENT}
                      placement={PLACEMENT__TOP_END}
                      style={{
                        backgroundColor: (
                          MatchPageUI.CardChipBar.matchType.color
                        )
                      }}
                    >
                      {(LABEL__TAG__MATCH_TYPE__ENGAGEMENT)}
                    </Chip>
                  )}

                  {/** LABELS: OWNER SHIP && PRIOR SUBMISSION && CALIBRATION */}
                  {this.state.ownerShipChip}
                </Box>

                {/** ACTIONS */}
                <Box row wAuto noWrap
                  acl={Core.isAdminOrTrusted()}
                  className='flex-align-right-bottom'
                  style={{ marginRight: '-0.5rem' }}
                >
                  {Core.isAdmin({ action: ACCOUNT_ACTION__VIEW_ENGAGEMENT }) && engagement.id && (
                    <IconButton
                      onClick={(event) => Core.openPopUp(`/engagement/view/${engagement.id}`, 1600)}
                      icon='visibility'
                    />
                  )}
                  {Core.isAdmin({ action: ACCOUNT_ACTION__MATCH_CANDIDATE }) && (
                    <NavLink openInNewTab
                      to={`/candidate/match/${(match.id)}`}
                      icon='fact_check'
                    />
                  )}
                  <MoreOptionsMenu
                    row={{
                      original:
                        !!engagement.id
                          ? mapEngagement({ ...engagement })
                          : mapCandidate({ ...match })
                    }}
                    context={{
                      config: {
                        moreMenuOptions: [
                          ...(
                            !!engagement.id
                              ? moreMenuOptionsEngagements
                              : moreMenuOptionsCandidates
                          ),
                          { label: MDASH },
                          ..._menuOptions
                        ],
                      }
                    }}
                  />
                </Box>

              </Box>
            </Box>

          </Box>
        </Card>

        <CreateDisagreement Controller={this} />

        <ManageEngagement
          acl={YES(engagement.id)}
          engagement={engagement}
          open={wantsUpdateEngagement}
          closeParentPopup={this.closeParentPopup}
          afterUpdateEngagement={this.afterUpdateEngagement}
        />

        <MatchDecisionDetails
          acl={YES(engagement.id)}
          Controller={this}
        />

      </RefBox>
    );
  }
}

export default SingleCandidateCard;
